<template>
  <span
  v-if="statusClasses[status as keyof typeof statusClasses]"
  :class="[
      'inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-medium',
      statusClasses[status as keyof typeof statusClasses],
  ]"
  >
      <span class="relative flex h-2 w-2">
          <span
          :class="[
              'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
              statusClasses[status as keyof typeof statusClasses].split(' ')[0],
          ]"
          ></span>
          <span
          :class="[
              'relative inline-flex h-2 w-2 rounded-full',
              statusClasses[status as keyof typeof statusClasses].split(' ')[0],
          ]"
          ></span>
      </span>
      {{ statusLabels[status as keyof typeof statusLabels] }}
  </span>
</template>

<script setup lang="ts">
const statusClasses = {
  activeSubscriber: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
  inactiveSubscriber: 'bg-red-400 text-red-50 bg-red-400/10',
  nonSubscriber: 'bg-zinc-500 text-zinc-50 bg-zinc-500/10',
}
const statusLabels = {
  activeSubscriber: 'Assinante ativo',
  inactiveSubscriber: 'Assinante inativo',
  nonSubscriber: 'Não assinante',
}
defineProps<{
  status: any
}>()
</script>

